import React from "react";
import { Card, theme, Typography } from "antd";
import { CARD_PADDING } from "./constants";

const { Text } = Typography;

interface SectionCardProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  extra?: React.ReactNode;
  children: React.ReactNode;
  /** Remove default card body padding (e.g. when hosting a full-bleed Table) */
  noPadding?: boolean;
  style?: React.CSSProperties;
}

const SectionCard: React.FC<SectionCardProps> = ({
  title,
  description,
  extra,
  children,
  noPadding = false,
  style,
}) => {
  const { token } = theme.useToken();

  return (
    <Card
      styles={{
        header: {
          padding: `0 ${CARD_PADDING}px`,
          minHeight: 44,
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
          fontSize: 13,
          fontWeight: 600,
        },
        body: {
          padding: noPadding ? 0 : CARD_PADDING,
        },
      }}
      title={
        title ? (
          <div style={{ display: "flex", flexDirection: "column", gap: 2, padding: "10px 0" }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: token.colorText }}>{title}</span>
            {description && (
              <Text style={{ fontSize: 12, color: token.colorTextSecondary, fontWeight: 400 }}>
                {description}
              </Text>
            )}
          </div>
        ) : undefined
      }
      extra={extra}
      style={{
        borderRadius: token.borderRadiusLG,
        border: `1px solid ${token.colorBorderSecondary}`,
        background: token.colorBgContainer,
        ...style,
      }}
    >
      {children}
    </Card>
  );
};

export default SectionCard;
